<template>
  <div class="game-step-by-step-wrapper">
    <div
      v-for="(image, index) in imageData"
      :key="'image_' + index"
      class="main-image-container"
      :style="getImageStyle(image)"
      @click="closePopUp()"
    ></div>
    <div
      class="text-element"
      v-for="(item, index) in staticText"
      :key="'text_' + index"
      :style="getStaticTextStyle(item)"
      v-html="item.text"
    ></div>
    <div class="step-container">
      <tr-comics
        v-for="(step, index) in mainItem"
        :key="'step_' + index"
        :config="setConfig(step)"
        :step-data="step"
        :show-step="showTab[index]"
        @close-modal="closeModal"
        :style="getStepStyle(step)"
      ></tr-comics>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import defaultMixin from '../../mixins/defaultMixin';
import * as utils from '../../Utils/inputUtils';
// import TrStep from './TrStep/TrStep';
import TrComics from './TrComics/TrComics';
export default {
  name: 'tr-step-by-step-comics',
  components: { TrComics },
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      imageData: [],
      staticText: [],
      mainItem: [],
      showTab: [],
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.mainItem = this.prepareData();
      this.mainItem = _.map(this.mainItem, (item, index) => {
        return _.merge({ id: index + 1, index }, item);
      });
      this.showTab = _.map(this.mainItem, (item) => {
        return { show: false };
      });
    },
    processData(node, staticText, imageArray, parentNode) {
      if (node.items) {
        // if(status.lengt>0){}
        if (node.pick && node.shuffle) {
          node.items = _.sampleSize(_.cloneDeep(node.items), node.pick);
        } else if (node.pick) {
          node.items = _.take(_.cloneDeep(node.items), node.pick);
        }
        if (node.shuffle) {
          node.items = _.shuffle(node.items);
        }
        if (node.staticText) {
          staticText.push(node.staticText);
        }
        if (node.imageData) {
          imageArray.push(node.imageData);
        }
        return _.flattenDeep(
          _.map(node.items, (item) => {
            return this.processData(item, staticText, imageArray, node);
          })
        );
      }
      // let status = _.filter(node.items, 'staticIndex');
      if (node.staticText) {
        staticText.push(node.staticText);
      }
      if (node.imageData) {
        imageArray.push(node.imageData);
      }
      return node;
    },
    prepareData() {
      let staticText = [];
      let imageArray = [];
      let pick = this.startGameConfig.pick;
      let data = _.cloneDeep(this.startGameConfig.items);
      let staticIndexArray = _.filter(data, (item) => {
        return !_.isNil(item['staticIndex']);
      });
      if (staticIndexArray.length > 0) {
        pick = this.startGameConfig.pick - staticIndexArray.length;
        data = _.difference(data, staticIndexArray);
      }
      if (this.startGameConfig.items && this.startGameConfig.pick && this.startGameConfig.shuffle) {
        data = _.sampleSize(_.cloneDeep(data), pick);
      } else if (this.startGameConfig.items && pick) {
        data = _.take(_.cloneDeep(data), pick);
      }
      _.each(staticIndexArray, (item) => {
        data.push(item);
      });
      data = _.flattenDeep(
        _.map(data, (item) => {
          return this.processData(item, staticText, imageArray, this.startGameConfig);
        })
      );
      /** add image layout */
      this.imageData = imageArray;
      if (this.startGameConfig.mainImage) {
        this.imageData.unshift(this.startGameConfig.mainImage);
      } else if (this.startGameConfig.background) {
        this.imageData = Object.assign({}, { imagePath: this.startGameConfig.background });
      }
      /** shuffle words in box */
      if (this.startGameConfig.words) {
        this.words = _.shuffle(_.cloneDeep(this.startGameConfig.words));
      }
      /** set staticIndex (fixed position) */
      let sData = {};
      let staticData = _.filter(data, (item) => {
        return !_.isNil(item.staticIndex);
      });
      if (staticData.length > 0) {
        staticData = _.sortBy(_.cloneDeep(staticData), ['staticIndex']);
        data = _.map(data, (item) => {
          if (_.isNil(item.staticIndex)) {
            return item;
          }
        });
      }
      data = _.compact(data);
      sData = _.difference(data, staticData);
      _.each(staticData, (item) => {
        sData.splice(item.staticIndex, 0, item);
      });
      data = sData;
      /** add layout image */
      if (this.startGameConfig.layoutImage && this.startGameConfig.layoutImage.length) {
        let imageList = _.cloneDeep(this.imageData);
        let first;
        if (this.startGameConfig.mainImage) {
          first = _.head(imageList);
          imageList = _.tail(imageList);
        }
        this.imageData = _.map(_.cloneDeep(imageList), (item, index) => {
          return _.defaultsDeep(_.cloneDeep(item), _.cloneDeep(this.startGameConfig.layoutImage[index]));
        });
        if (this.startGameConfig.mainImage) {
          this.imageData.unshift(first);
        }
      }
      /** add static text */
      if (this.startGameConfig.staticText) {
        if (
          this.startGameConfig.staticText[0] &&
          this.startGameConfig.staticText[0].items &&
          this.startGameConfig.staticText[0].items.length > 0
        ) {
          if (this.startGameConfig.staticText[0].pick) {
            staticText = _.map(this.startGameConfig.staticText, (elem) => {
              return _.take(_.cloneDeep(elem.items), elem.pick);
            });
            staticText = _.flatten(staticText);
            // staticText.push(_.sampleSize(_.cloneDeep(staticText[0].items), staticText[0].pick));
          }
        }
      }
      if (staticText.length > 0) {
        this.staticText = _.map(staticText, (item, index) => {
          if (this.startGameConfig.layoutStaticText) {
            return Object.assign(item, this.startGameConfig.layoutStaticText[index]);
          } else {
            return item;
          }
        });
      }
      this.textItem = _.map(_.cloneDeep(data), (item, index) => {
        if (this.startGameConfig.layoutItems && this.startGameConfig.layoutItems[index]) {
          return _.defaultsDeep(item, _.cloneDeep(this.startGameConfig.layoutItems[index]));
        }
        return item;
      });
      /**
       * add type to history
       */
      this.textItem = _.map(_.cloneDeep(data), (item) => {
        if (this.startGameConfig.type) {
          return _.defaultsDeep(item, {
            type: _.cloneDeep(this.startGameConfig.type),
          });
        }
        return item;
      });
      /**
       * add words box to game
       */
      if (this.startGameConfig.words) {
        let syncData = this.startGameConfig.boxConfig.syncData;
        this.words = this.startGameConfig.words;
        if (this.startGameConfig.boxConfig && syncData) {
          this.words = _.intersection(
            this.startGameConfig.words,
            _.flattenDeep(
              _.map(this.textItem, (item) => {
                if (item[syncData]) {
                  return [...item[syncData]];
                } else if (item.markers) {
                  return _.flattenDeep(
                    _.map(item.markers, (item) => {
                      return [...item[syncData]];
                    })
                  );
                }
                return [...item[syncData]];
              })
            )
          );
        }
        this.words = _.shuffle(this.words);
      }
      return _.cloneDeep(this.textItem);
    },
    /**
     * test if object objectExist
     * @method objectExist
     * @param  {*}    item testiing element
     * @return {Boolean}         true if is object
     */
    objectImageExist(item) {
      return _.isObject(item) && !_.isNil(item.imagePath);
    },
    getImage(item) {
      return 'static/' + item.imagePath;
      // return 'assets/config/' + item.imagePath;
    },
    getImageStyle(imageData) {
      if (_.isObject(imageData) && imageData.imagePath) {
        if (!imageData.pos) {
          imageData = Object.assign({}, imageData, {
            pos: {
              x: 0,
              y: 0,
            },
          });
        }
        if (!imageData.height) {
          imageData = Object.assign({}, imageData, {
            height: 358,
          });
        }
        if (!imageData.width) {
          imageData = Object.assign({}, imageData, {
            width: 1850,
          });
        }
      }
      return _.merge({ position: 'absolute' }, this.getCustomStyle(imageData), {
        // 'position': 'absolute',
        'background-image': `url(${require(`__staticDir/${this.$store.getters.multibookType}/${imageData.imagePath}`)})`,
        top: utils.elementTopPosition(imageData.pos.y, imageData.offsetVertical),
        left: utils.elementLeftPosition(imageData.pos.x, imageData.offsetHorizontal),
        width: utils.elementWidth(imageData.width),
        height: utils.elementHeight(imageData.height),
      });
    },
    getStaticTextStyle(staticTextElement) {
      staticTextElement.offsetVertical = staticTextElement.offsetVertical
        ? staticTextElement.offsetVertical
        : this.startGameConfig.staticTextElementOffsetVertical;
      staticTextElement.offsetHorizontal = staticTextElement.offsetHorizontal
        ? staticTextElement.offsetHorizontal
        : this.startGameConfig.staticTextElementOffsetHorizontal;
      staticTextElement.width = staticTextElement.width
        ? staticTextElement.width
        : this.startGameConfig.staticTextElementWidth;
      staticTextElement.height = staticTextElement.height
        ? staticTextElement.height
        : this.startGameConfig.staticTextElementHeight;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(staticTextElement), {
        // 'position': 'absolute',
        top: utils.elementTopPosition(staticTextElement.pos.y, staticTextElement.offsetVertical),
        left: utils.elementLeftPosition(staticTextElement.pos.x, staticTextElement.offsetHorizontal),
        width: utils.elementWidth(staticTextElement.width),
        height: utils.elementHeight(staticTextElement.height),
      });
    },
    getBoxStyle(box) {
      box.x = box.x;
      box.y = box.y;
      box.width = box.width;
      box.height = box.height;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(box), {
        // 'position': 'absolute',
        left: utils.elementLeftPosition(box.x, 0, '%'),
        top: utils.elementTopPosition(box.y, 0, '%'),
        width: utils.elementWidth(box.width, '%'),
        height: utils.elementHeight(box.height, '%'),
      });
    },
    getStepStyle(item) {
      item.x = item.pos ? item.pos.x : undefined;
      item.y = item.pos ? item.pos.y : undefined;
      return _.merge({ position: 'absolute' }, this.getCustomStyle(item), {
        // 'position': 'absolute',
        left: utils.elementLeftPosition(item.x, 0, 'px'),
        top: utils.elementTopPosition(item.y, 0, 'px'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    closePopUp() {
      this.showTab = _.map(this.showTab, (item) => {
        return { show: false };
      });
    },
    stepChange(e, obj) {
      this.showTab[obj.index].show = obj.show;
    },
    closeAll(e, obj) {
      this.showTab = _.map(this.showTab, (item, index) => {
        return { show: obj.index === index ? true : false };
      });
    },
    closeModal(e) {
      this.showTab = _.map(this.showTab, (item, index) => {
        return { show: false };
      });
    },
    setConfig(item) {
      let width = 45;
      let height = 45;
      let fontSize = 29;
      let backgroundColor = 29;
      let color = 29;
      let cssStyle = {};
      if (this.startGameConfig.activeArea) {
        width = this.startGameConfig.activeArea.width;
        height = this.startGameConfig.activeArea.height;
        fontSize = this.startGameConfig.activeArea.fontSize;
        backgroundColor = this.startGameConfig.activeArea.backgroundColor;
        color = this.startGameConfig.activeArea.color;
        cssStyle = this.startGameConfig.activeArea.cssStyle;
      }
      return { width, height, fontSize, backgroundColor, color, cssStyle };
    },
  },
};
</script>
<style lang="scss" scoped>
.game-step-by-step-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  position: inherit;
  // background-image: url("~@/assets/icons/book/toolbox/przybornik_kosz.png");
  .main-image-container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;

    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
